import React from 'react';
import FundingSubmissionStatusBadge from './FundingSubmissionStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

const FundingSubmissionTable = ({ submissions, onView, onStatusChange, onDelete, onCreateDeal, savingId, creatingDealId }) => (
  <div className="overflow-x-auto">
    <table className="min-w-full text-left text-sm">
      <thead>
        <tr className="border-b border-[var(--fg-line)] text-[var(--fg-muted)]">
          <th className="px-3 py-2 font-medium">Client</th>
          <th className="px-3 py-2 font-medium">Lender</th>
          <th className="px-3 py-2 font-medium">Product</th>
          <th className="px-3 py-2 font-medium">Requested</th>
          <th className="px-3 py-2 font-medium">Status</th>
          <th className="px-3 py-2 font-medium">Documents</th>
          <th className="px-3 py-2 font-medium">Signature</th>
          <th className="px-3 py-2 font-medium">Submitted</th>
          <th className="px-3 py-2 font-medium">Follow-Up</th>
          <th className="px-3 py-2 font-medium">Actions</th>
        </tr>
      </thead>
      <tbody>
        {submissions.map((submission) => (
          <tr key={submission.id} className="border-b border-[var(--fg-line)]/70">
            <td className="px-3 py-3 font-medium text-[var(--fg-text)]">{submission.clientName || submission.fundingClientId}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{submission.lenderName}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{submission.productType}</td>
            <td className="px-3 py-3 text-[var(--fg-text)]">{formatCurrency(submission.requestedAmount)}</td>
            <td className="px-3 py-3"><FundingSubmissionStatusBadge status={submission.status} /></td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{submission.documentsStatus || '—'}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{submission.signatureStatus || '—'}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{formatDate(submission.submittedAt)}</td>
            <td className="px-3 py-3 text-[var(--fg-muted)]">{formatDate(submission.nextFollowUpAt)}</td>
            <td className="px-3 py-3">
              <div className="flex flex-wrap gap-1">
                <button type="button" onClick={() => onView(submission)} className="rounded-lg px-2 py-1 text-xs text-[var(--fg-accent)] hover:bg-[var(--fg-accent-soft)]">View</button>
                {onCreateDeal && ['Approved', 'Funded'].includes(submission.status) ? (
                  <button
                    type="button"
                    disabled={creatingDealId === submission.id}
                    onClick={() => onCreateDeal(submission)}
                    className="rounded-lg px-2 py-1 text-xs text-[var(--fg-accent)] hover:bg-[var(--fg-accent-soft)] disabled:opacity-40"
                  >
                    {creatingDealId === submission.id ? 'Creating...' : 'Create Deal'}
                  </button>
                ) : null}
                {['Submitted', 'Under Review', 'Approved', 'Declined', 'Funded'].map((status) => (
                  <button
                    key={status}
                    type="button"
                    disabled={savingId === submission.id || submission.status === status}
                    onClick={() => onStatusChange(submission, status)}
                    className="rounded-lg px-2 py-1 text-xs text-[var(--fg-muted)] hover:bg-[var(--fg-panel-soft)] disabled:opacity-40"
                  >
                    {status}
                  </button>
                ))}
                <button type="button" onClick={() => onDelete(submission)} className="rounded-lg px-2 py-1 text-xs text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/30">Delete</button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default FundingSubmissionTable;
